import { AutoBonusSummaryResponse } from "../../../domain/models/integration/auto-bonus-summary.model";

type UnknownRecord = Record<string, unknown>;

const isRecord = (value: unknown): value is UnknownRecord =>
  typeof value === "object" && value !== null && !Array.isArray(value);
const isString = (value: unknown): value is string => typeof value === "string";
const isNumber = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value);
const isOptionalNumber = (value: unknown): boolean =>
  value === undefined || value === null || isNumber(value);
const isOptionalString = (value: unknown): boolean =>
  value === undefined || value === null || isString(value);

export function isAutoBonusSummaryResponse(
  value: unknown,
): value is AutoBonusSummaryResponse {
  return isRecord(value) &&
    isNumber(value["totalCarsToPay"]) &&
    isOptionalNumber(value["totalPayments"]) &&
    Array.isArray(value["installmentAmounts"]) &&
    value["installmentAmounts"].every(isNumber) &&
    isNumber(value["totalAmountToPay"]) &&
    isOptionalNumber(value["totalPaid"]) &&
    isOptionalNumber(value["difference"]) &&
    isString(value["paymentDate"]) &&
    isOptionalString(value["currency"]);
}
